import { useEffect } from "react";
import { useAssistantScappRegistry } from "./viewContextStore";

export default function useAssistantScappContext(descriptor) {
  const registry = useAssistantScappRegistry();

  useEffect(() => {
    if (!registry) return undefined;

    registry.setRegisteredScappContext(descriptor || null);

    return () => {
      registry.clearRegisteredScappContext();
    };
  }, [descriptor, registry]);
}
